<ion-app>
  @if (isTaskDetailsLoaded) {
    <ion-router-outlet></ion-router-outlet>
  }

  @if (!isTaskDetailsLoaded) {
    <ion-header style="border-bottom: 0.5px solid gray;">
      <ion-toolbar class="header-background-style" style="position: relative; min-height: 56px;">
        <ion-title>
          @if (_appServices?._themingService?.currentLogo?.value?.logoUrl) {
            <img
              src="{{_appServices._themingService.currentLogo.value.logoUrl}}" class="header-logo" />
          }
        </ion-title>
      </ion-toolbar>
    </ion-header>
  }
  @if (!isTaskDetailsLoaded) {
    <ion-content class="white-background ion-text-center">
      <div fxLayout="column" fxLayoutAlign="space-around center" class="loading-screen-content">
        <h2 class="welcometext">Welcome to your Assisted-Inspection</h2>
        <ion-spinner name="lines" class="loader-spinner"></ion-spinner>
        <p class="loadingdetails font-size-18 inter-regular color-netral-700">We are loading your details</p>
        <p class="refreshscreen color-netral-700 inter-regular font-size-14">Please do not refresh or close this screen
        </p>
      </div>
      <div fxLayout="column" fxLayoutAlign="space-around center" class="footer-content">
        <div class="footer color-netral-500">
          Powered by Digital Eyes™
        </div>
      </div>
    </ion-content>
  }
</ion-app>